var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3888 7.84705C25.3888 7.84705 25.1386 6.08255 24.3709 5.30552C23.3972 4.28567 22.3058 4.28062 21.8053 4.22092C18.2222 3.96191 12.8473 3.96191 12.8473 3.96191H12.8362C12.8362 3.96191 7.46147 3.96191 3.87824 4.22092C3.37771 4.28062 2.2867 4.28567 1.31266 5.30552C0.544956 6.08255 0.295133 7.84705 0.295133 7.84705C0.295133 7.84705 0.0390625 9.91913 0.0390625 11.9912V13.9338C0.0390625 16.0058 0.295138 18.0779 0.295138 18.0779C0.295138 18.0779 0.544961 19.8424 1.31267 20.6195C2.28671 21.6393 3.56616 21.6071 4.13602 21.7139C6.1845 21.9104 12.8418 21.9712 12.8418 21.9712C12.8418 21.9712 18.2222 21.9631 21.8053 21.704C22.3058 21.6443 23.3972 21.6393 24.3709 20.6195C25.1386 19.8424 25.3888 18.0779 25.3888 18.0779C25.3888 18.0779 25.6445 16.0058 25.6445 13.9338V11.9912C25.6445 9.91913 25.3888 7.84705 25.3888 7.84705Z",
    fill: "#DC2217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1984 16.2882L10.1973 9.09375L17.116 12.7035L10.1984 16.2882Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6054,
    height: 25.6054,
    fill: "white",
    transform: "translate(0.0390625 0.163086)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.49725a8ffbda8ff07705145fe58e617b.svg";
export { ForwardRef as ReactComponent };